import { render, staticRenderFns } from "./SupplementaryIcon.vue?vue&type=template&id=47295c94&scoped=true"
import script from "./SupplementaryIcon.vue?vue&type=script&lang=js"
export * from "./SupplementaryIcon.vue?vue&type=script&lang=js"
import style0 from "./SupplementaryIcon.vue?vue&type=style&index=0&id=47295c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47295c94",
  null
  
)

export default component.exports